/**
 * The amount the payment dialog shows as due, once a tender is chosen.
 *
 * The cart quote is priced against a placeholder method (`pickQuoteMethod`), so
 * a PAYMENT-gated discount — "Rp 20.000 off with BCA card", say — is missing
 * from it, or present for a tender the customer did not pick. The terminal was
 * armed with the right figure while the screen said another. So the dialog
 * re-prices for the tender actually chosen, and settles on what the sale charged:
 *
 *   1. `charged`     — the sale's own `totalAmount`: what the EDC / e-money
 *                      reader / QRIS was asked for. Final once known.
 *   2. `methodQuote` — `POST /sale/quote` with the chosen method.
 *   3. `cartTotal`   — the placeholder-priced cart figure, ONLY after the
 *                      method quote failed. The server still charges correctly;
 *                      this is the old behaviour, kept as a last resort.
 *
 * `null` while the method quote is in flight: showing the placeholder figure in
 * the meantime is exactly the wrong number this exists to remove.
 */
export function resolveAmountDue({
  charged,
  methodQuote,
  methodQuoteFailed,
  cartTotal,
}: {
  charged: number | null | undefined;
  methodQuote: number | null | undefined;
  methodQuoteFailed: boolean;
  cartTotal: number;
}): number | null {
  if (isAmount(charged)) return charged;
  if (isAmount(methodQuote)) return methodQuote;
  return methodQuoteFailed ? cartTotal : null;
}

function isAmount(v: number | null | undefined): v is number {
  return typeof v === 'number' && Number.isFinite(v) && v >= 0;
}
